<div class="exterior mt-2">
  <ng-container *ngIf="main.length">
    <app-commonratingsedan [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['sedan']"></app-commonratingsedan>
    <!-- <app-sedan [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['sedan']"></app-sedan> -->
    <app-commonratingbus [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['bus']"></app-commonratingbus>
    <app-commonratingtruck-single [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckSingle']"></app-commonratingtruck-single>
    <app-commonratingtruck-double [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckDouble']"></app-commonratingtruck-double>
    <app-commonratingsuv [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['suv']"></app-commonratingsuv>
    <app-commonratingvan [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['cargo']"></app-commonratingvan>
  </ng-container>

  <loader [position]="{absolute: true}" [active]="loaded"></loader>
</div>